
import React, { useState } from 'react'

import api from '@percept/api'

import { Typography, Box, Alert } from '@percept/mui'

import * as Buttons from './Buttons'
import * as Inputs from './Inputs'

import { PasswordRequirements } from './PasswordRequirements'

import getMessage from './getMessage'

import { isValidCode, isValidPassword } from './utils'

import { AuthComponentProps, AuthInputs } from './lib'


const { CORE_API_ROOT } = process.env

const VERSIONED_CORE_API_ROOT = `${CORE_API_ROOT}/v1`


const ResetPassword = ({
  inputs,
  dispatch,
  updateInputs,
  attemptSignIn,
  loading,
  error,
  classes,
  ButtonComponent,
  AuthInputProps = {},
}: AuthComponentProps): JSX.Element => {

  const [sending, setSending] = useState(false)

  const updateHandler = (name: keyof AuthInputs) => (
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      const value = e.target.value
      updateInputs({ [name]: value })
    }
  )

  const confirmPasswordReset = (): void => {
    const { username, code, password } = inputs
    dispatch({ type: 'SET_ERROR', payload: null })
    setSending(true)
    api({
      baseURL: VERSIONED_CORE_API_ROOT,
      url: '/auth/forgotten-password-confirmation',
      method: 'POST',
      data: { username, token: code, password },
    }).then( response => {
      setSending(false)
      attemptSignIn()
      dispatch({ type: 'SET_ERROR', payload: null })
    }).catch( e => {
      setSending(false)
      dispatch({ type: 'SET_ERROR', payload: e.response.data })
    }).finally(() => {
      setSending(false)
    })
  }

  return (
    <form
      onSubmit={(e): void => {
        e.preventDefault()
      }}>

      <Typography
        className={classes.heading}
        variant='h3'>
        Reset Password
      </Typography>

      { error ? (
        <Alert
          my={3}
          variant='error'
          message={getMessage(error)} />
      ) : (
        <Alert
          my={3}
          variant='info'
          header='Check Verification Code'
          message={`Please check your email ${inputs.username && `at ${inputs.username}`}`} />
      )}

      <Box mb={5}>
        <PasswordRequirements
          password={inputs.password || ''}
          my={3} />

        <Inputs.Code
          autoFocus
          {...AuthInputProps}
          value={inputs.code || ''}
          onChange={updateHandler('code')} />

        <Inputs.Password
          {...AuthInputProps}
          placeholder='New Password'
          disabled={!isValidCode(inputs.code)}
          value={inputs.password || ''}
          onChange={updateHandler('password')} />

      </Box>

      <Buttons.Confirm
        ButtonComponent={ButtonComponent}
        type='submit'
        disabled={sending || loading || !isValidCode(inputs.code) || !isValidPassword(inputs.password)}
        loading={sending || loading}
        onClick={confirmPasswordReset}>
        Confirm New Password
      </Buttons.Confirm>

      <Box mt={3}>
        <Buttons.BackToSignIn
          ButtonComponent={ButtonComponent}
          onClick={(): void => {
            dispatch({ type: 'SET_ERROR', payload: null })
            dispatch({ type: 'SIGN_IN' })
          }} />
      </Box>

    </form>
  )
}

export default ResetPassword
